import { render } from "./SelectApp.vue?vue&type=template&id=c5e5dc0e&scoped=true"
import script from "./SelectApp.vue?vue&type=script&lang=js"
export * from "./SelectApp.vue?vue&type=script&lang=js"

import "./SelectApp.vue?vue&type=style&index=0&id=c5e5dc0e&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5e5dc0e"]])

export default __exports__